import root from './root'
import storeApiRouter from './storeApiRouter'
import adminApiRouter from './adminApiRouter'
import devToolsApiRouter from './devToolsApiRouter'
import category from './category'
import store from './store'
import business from './business'
import menu from './menu'
import order from './order'
import pos from './pos'
import mail from './mail'
import role from './role'
import user from './user'
import automaticDiscount from '@/utils/service/automaticDiscount'

export const list = {
	...root,
	storeApiRouter,
	adminApiRouter,
	devToolsApiRouter,
	category,
	store,
	business,
	menu,
	order,
	pos,
	mail,
	role,
	user,
	automaticDiscount,
}

export default Vue => {
	Vue.prototype.$http = list
}
